"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const ListContext = /*#__PURE__*/React.createContext({
  size: null,
  type: null
});
ListContext.displayName = "ListOrbitContext";
var _default = ListContext;
exports.default = _default;